export default {
  props: {
    opacity: {
      type: Number,
      default: 1
    },
    classes: {
      type: String,
      default: ''
    },
    model: String
  },
  data: function () {
    return {
      loaded: false,
      opacityClass: 'opa-1'
    }
  },
  mounted () {
  },
  methods: {
    onLoaded () {
      this.opacityClass = ' opa-' + parseInt(this.opacity * 10)
      this.loaded = true
    }
  }
}
